export default __webpack_public_path__ + "static/mongo-6170bacefd8a1f69ca745f6eef6e9124.png";